/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ReportCategoryDto } from '../../models/report-category-dto';

export interface ReportsGetAllReportCategories$Params {
}

export function reportsGetAllReportCategories(http: HttpClient, rootUrl: string, params?: ReportsGetAllReportCategories$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ReportCategoryDto>>> {
  const rb = new RequestBuilder(rootUrl, reportsGetAllReportCategories.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ReportCategoryDto>>;
    })
  );
}

reportsGetAllReportCategories.PATH = '/reports/getallcategories';
